import PropTypes from "prop-types";
import React from "react";
import PhoneInput from "react-phone-input-2";

import FormInputError from "../formInputGroups/FormInputError";

function PhoneNumber(props) {
  const { value, name, formik, ...rest } = props;

  return (
    <div>
      <PhoneInput
        placeholder="(555) 555-5555"
        containerClass="form-control-tel"
        country={"us"}
        countryCodeEditable={false}
        enableSearch={false}
        value={value}
        autoFormat={true}
        maxLength={10}
        disableDropdown={true}
        disableSearchIcon={true}
        onlyCountries={["us"]}
        onChange={(phoneNumber, country) => {
          // Remove any non-digit characters
          const digits = phoneNumber.replace(/\D/g, "");
          // Remove country code (1) if present at the start
          const phoneWithoutCountry = digits.startsWith("1") ? digits.slice(1) : digits;
          // Take only the first 10 digits
          const truncatedPhone = phoneWithoutCountry.slice(0, 10);
          // Format with country code
          if (truncatedPhone) {
            formik?.setFieldValue(name, "+1-" + truncatedPhone);
          }
        }}
        {...rest}
      />
      <FormInputError formik={formik} name={name} />
    </div>
  );
}

export const defaultProps = {
  className: "",
  label: "",
  defaultCountry: "us",
  placeholder: "(555) 555-5555",
};

export const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  autoComplete: PropTypes.string,
  onChange: PropTypes.func,
  displayInitialValueAsLocalNumber: PropTypes.bool,
  defaultCountry: PropTypes.string,
  flagUrl: PropTypes.string,
  countrySelectComponent: PropTypes.elementType,
  reset: PropTypes.any,
  formik: PropTypes.object,
};

PhoneNumber.defaultProps = defaultProps;

PhoneNumber.propTypes = { ...propTypes, type: PropTypes.number };

export default PhoneNumber;
